import React from 'react';
import { Bar } from 'react-chartjs-2';

const BarGraph = ({ series, className }) => {
	const labels = series
		.map((category) => category.dataset.map((series) => series.label))
		.flat()
		.filter((value, index, self) => self.indexOf(value) === index);
	const formattedData = {
		labels,
		datasets: series.map(({ label, dataset, backgroundColor }) => {
			return {
				label,
				backgroundColor,
				data: labels.map((label) => dataset.find((d) => d.label === label).value)
			};
		})
	};

	// option documentation:
	// https://www.chartjs.org/docs/latest/charts/bar.html#dataset-configuration
	let options = {
		responsive: true,
		spanGaps: true,
		maintainAspectRatio: false,
		gridLines: {
			display: false,
			zeroLineWidth: 0
		},
		tooltips: {
			mode: 'index',
			intersect: false,
			position: 'nearest'
		},
		legend: {
			display: false
		},
		scales: {
			xAxes: [
				{
					stacked: true,
					display: false
				}
			],
			yAxes: [
				{
					stacked: true
				}
			]
		}
	};

	return <Bar className={className} data={formattedData} options={options} />;
};

export default BarGraph;
